import React from 'react';
import { Box, Typography, IconButton, useTheme, useMediaQuery, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import ChurchIcon from '@mui/icons-material/Church';
import { useAuth } from '../../context/AuthContext';
import { useHeader } from '../../context/HeaderContext';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../common/LanguageSelector';

const Header = () => {
  const { user } = useAuth();
  const { showHeader, hideHeader } = useHeader();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const firstName = user?.firstName || '';
  const lastName = user?.lastName || '';
  const churchName = user?.church?.name || '';

  if (!showHeader) return null;

  // return (
  //   <Box 
  //     sx={{ 
  //       p: 2, 
  //       pb: 1.5,
  //       mb: 2,
  //       background: 'linear-gradient(135deg, #9945FF 0%, #8A2BE2 100%)',
  //       color: 'white',
  //       borderRadius: { xs: 0, sm: 2 },
  //       position: 'relative',
  //       zIndex: 1,
  //     }}
  //   >
  //     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
  //       {/* Top Section with Close Button and Language Selector */}
  //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  //         <Box sx={{ width: '140px' }}>
  //           <LanguageSelector variant="header" />
  //         </Box>
  //         <IconButton
  //           onClick={hideHeader}
  //           sx={{
  //             color: 'white',
  //           }}
  //           size="small"
  //         >
  //           <CloseIcon />
  //         </IconButton>
  //       </Box>

  //       {/* Welcome Message */}
  //       <Box>
  //         <Typography 
  //           variant="h5" 
  //           component="h1" 
  //           gutterBottom
  //           sx={{ 
  //             color: 'white',
  //             fontWeight: 600,
  //             textShadow: '0px 2px 4px rgba(0,0,0,0.1)',
  //           }}
  //         >
  //           {t('common.welcome')}, {firstName}! 👋
  //         </Typography>
          
  //         <Typography 
  //           variant="subtitle1" 
  //           sx={{ 
  //             color: 'rgba(255,255,255,0.9)',
  //             textShadow: '0px 1px 2px rgba(0,0,0,0.1)',
  //           }}
  //         >
  //           {t('dashboard.subtitle', 'Let\'s make beautiful worship together')}
  //         </Typography>
  //       </Box>

  //       {/* User Info Box */}
  //       <Box 
  //         sx={{ 
  //           mt: 1,
  //           p: 2,
  //           backgroundColor: 'rgba(255, 255, 255, 0.1)',
  //           borderRadius: 1,
  //           backdropFilter: 'blur(10px)',
  //           display: { xs: 'block', md: 'none' },
  //         }}
  //       >
  //         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
  //           <Box sx={{ display: 'flex', alignItems: 'center' }}>
  //             <PersonIcon sx={{ color: 'white', mr: 1 }} />
  //             <Typography 
  //               variant="body1" 
  //               sx={{ 
  //                 color: 'white',
  //                 fontWeight: 500,
  //               }}
  //             >
  //               {firstName} {lastName}
  //             </Typography>
  //           </Box>

  //           <Box sx={{ display: 'flex', alignItems: 'center' }}>
  //             <ChurchIcon sx={{ color: 'white', mr: 1 }} />
  //             <Typography 
  //               variant="body1" 
  //               sx={{ 
  //                 color: 'white',
  //                 fontWeight: 500,
  //               }}
  //             >
  //               {churchName}
  //             </Typography>
  //           </Box>
  //         </Box>
  //       </Box>
  //     </Box>
  //   </Box>
  // );
};

export default Header;
